import type { FaireThemeEntity } from "../../entity_types/theme";

export const quirky_conversation_starters: FaireThemeEntity = {
  token: "quirky-conversation-starters",
  type: "theme",
  name: "Quirky Conversation Starters",
  description: "Playful and kitschy accessories for impulse sales -- miniature ramen bowls, iconic snack-themed earrings.",
  teaser: "Fun, expressive impulse buys your beauty clients will love.",
  detail: "Your beauty lounge customers look for fun, expressive final touches. Built around the whimsical Chiffonier items in your cart -- Ramen Earrings, Lays Classic Chips Earrings, Sanrio Cuties.",
  bgColor: "#F0D4C4",
  exactProducts: true,
  retailerToken: "r_v79pcsx8up",
  productTokens: [
    "p_x8zn8z9mdw",
    "p_5lazl70x",
    "p_ps3ufaemx5",
    "p_9ebda6svmo",
    "p_xpyyzvehfy",
    "p_6rm9cthdfr",
    "p_juex45tn7n",
    "p_vwssret42y",
    "p_egnnzqszi6",
    "p_kk9u5fmpf9",
    "p_bryjg59c5k",
    "p_mxau2n7tg4",
    "p_u3fcq7r777",
    "p_74jb4dfpzt",
    "p_ze2mdxspej",
    "p_kjwfdfzbjt",
    "p_abkkzv5z3b",
    "p_ju2puhctrf",
    "p_vkva66tczr",
  ],
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00Z",
    importedBy: "notion-v2-import",
  },
};
